import React from 'react';

interface SkeletonProps {
  className?: string;
  /** Short-form helper for a single pulsing rect */
  w?: string; h?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({ className = '', w, h }) => (
  <div
    className={`animate-pulse bg-bg-elevated/60 rounded ${className}`}
    style={{ width: w, height: h }}
    aria-hidden="true"
  />
);

/** Pre-composed skeleton for a stats card grid (e.g., MapView County Overview). */
export const StatsGridSkeleton: React.FC<{ count?: number }> = ({ count = 6 }) => (
  <div className="grid grid-cols-2 md:grid-cols-6 gap-4">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="bg-bg-raised border border-border-base rounded-lg p-4">
        <Skeleton className="h-3 w-20 mb-2" />
        <Skeleton className="h-7 w-16" />
      </div>
    ))}
  </div>
);

/** Pre-composed skeleton for a table body (used while rows load). */
export const TableRowSkeleton: React.FC<{ cols?: number; rows?: number }> = ({
  cols = 5,
  rows = 6,
}) => (
  <div className="space-y-2" role="status" aria-label="Loading data">
    {Array.from({ length: rows }).map((_, r) => (
      <div key={r} className="flex items-center gap-3 py-2 border-b border-border-base">
        {Array.from({ length: cols }).map((__, c) => (
          <Skeleton key={c} className="h-4" w={c === 0 ? '40%' : `${100 / cols - 5}%`} />
        ))}
      </div>
    ))}
  </div>
);

export default Skeleton;
